import { IntlShape } from "react-intl";

/**
 * The model's confidence as a percentage with at most one decimal: 0,949 → "94,9%", 0,95 → "95%".
 *
 * Not rounded to whole percents: the gate sits at 0,95, so a rejected 0,949 would read as "95%" on a
 * row that says the model was not confident enough.
 */
export const formatConfidence = (intl: IntlShape, confidence: number): string =>
  intl.formatNumber(confidence, { style: "percent", maximumFractionDigits: 1 });
